import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { EmailContentService } from 'src/app/email-content.service';
import { ReadPec } from 'src/app/models';
import { TOKEN_HOLDER, TokenHolder } from './TokenHolder';

@Component({
  selector: 'app-communication-button',
  templateUrl: './communication-button.component.html',
  styleUrls: ['./communication-button.component.css'],
})
export class CommunicationButtonComponent implements OnInit {
  @Input() legacy: '';

  constructor(
    private emailContentService: EmailContentService,
    @Inject(TOKEN_HOLDER) private tokenHolder: TokenHolder
  ) {
  }

  ngOnInit(): void {}

  get readPec(): ReadPec {
    return this.emailContentService.readPec;
  }

  get fileLoading(): boolean {
    return this.emailContentService.fileLoading;
  }

  downloadFile(id: string, filename: string): void {
    this.emailContentService.downloadFile(id, filename, this.tokenHolder.value);
  }

  get containerClass(): string {
    if (this.isLegacy) {
      return 'legacy';
    } else {
      return '';
    }
  }

  get isLegacy(): boolean {
    return this.legacy != null;
  }


  get fileDownloadError(): boolean {
    return this.emailContentService.fileDownloadError;
  }

  set fileDownloadError(value: boolean) {
    this.emailContentService.fileDownloadError = value;
  }
}
